<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.User">User Management</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">

        <span class="select-quarter-width">
          <mat-form-field matTooltip="Name">
            <mat-label i18n="@@type.User.name">Username</mat-label>
            <input matInput formControlName="name" placeholder="Filter" [(ngModel)]="nameFilter" name="nameFilter"
              #nameFilterInput placeholder="Username" class="field-threequarter-width">
          </mat-form-field>
        </span>

        <span>&nbsp;</span>

        <mat-form-field matTooltip="Select a Business Unit from the list"
          [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.BusinessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnitFilterInput" [(ngModel)]="businessUnitFilter"
            #businessUnitFilterInput (ngModelChange)="businessUnitChanged($event)" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnit.buId}} - {{businessUnit.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a role from the list" [matTooltipDisabled]="disabledTooltip(this.role)">
          <mat-label i18n="@@type.Role">Role</mat-label>
          <mat-select formControlName="role" id="roleFilterInput" [(ngModel)]="roleFilter" #roleFilterInput
            (ngModelChange)="roleChanged($event)" [compareWith]="roleCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let role of roleSelectionList" [value]="role">
              {{role.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <span>&nbsp;</span>
        <span>
          <mat-label i18n="@@type.User.includeUsersInheritingRole">Include Users inheriting Role?</mat-label>
          <mat-slide-toggle formControlName="includeUsersInheritingRole" id="includeUsersInheritingRoleFilterInput"
            [(ngModel)]="includeUsersInheritingRoleFilter" color="primary" #includeUsersInheritingRoleFilterInput>
          </mat-slide-toggle>
        </span>
      </div>

      <div class="search-section export-section">
        <mat-form-field matTooltip="Select a filter for Enabled state"
          [matTooltipDisabled]="disabledTooltip(this.enabled)">
          <mat-label i18n="@@type.User.enabled">Enabled State</mat-label>
          <mat-select formControlName="enabled" id="enabledFilterInput" [(ngModel)]="enabledFilter" #enabledFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true">Enabled</mat-option>
            <mat-option [value]="false">Disabled</mat-option>
          </mat-select>
        </mat-form-field>

        <span>&nbsp;</span>
        <span>
          <mat-label i18n="@@type.User.includeSystemProvided">Include System Provided?</mat-label>
          <mat-slide-toggle formControlName="systemProvided" id="systemProvidedFilterInput"
            [(ngModel)]="systemProvidedFilter" color="primary" #systemProvidedFilterInput>
          </mat-slide-toggle>
        </span>

        <span>&nbsp;</span>
        <!-- <mat-form-field class="field-quarter-width">
          <mat-label i18n="@@actions.reportRun.format">Format</mat-label>
          <mat-select [(ngModel)]="reportRun.outputFormat" formControlName="outputFormat" id="outputFormat"
            name="outputFormat">
            <mat-option *ngFor="let outputFormat of reportRun.outputFormats" [value]="outputFormat">
              {{outputFormat.name | refCodeDecode:'REPORT_OUTPUT_FORMAT' | async }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span>
          <mat-checkbox [(ngModel)]="reportRun.download" formControlName="download" id="download" name="download"
            class="field-quarter-width" labelPosition="after" disabled="{{reportRun.outputFormat?.downloadOnly}}"
            i18n="@@actions.reportRun.download">Download
          </mat-checkbox>
        </span>
        <button mat-raised-button color="primary" class="action-button" (click)="exportAction()" type="button"
          i18n="@@actions.reportRun" [disabled]="!isExportEnabled()">Export</button> -->

        <span><button class="action-button" mat-raised-button color="primary" (click)="clearFilters()"
            i18n="@@actions.clearFilters">Clear
            Filters</button></span>

      </div>
    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc" matSortActive="username"
          matSortDisableClear cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="username">
            <mat-header-cell [crud-column-header]="columns.column('name')" *matHeaderCellDef mat-sort-header cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.User.name"> Username </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              <span *ngIf="!isCurrentUser(element)">{{element.username}}</span>
              <span *ngIf="isCurrentUser(element)"><b>{{element.username}}</b></span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="details.attributes.businessUnit.buId">
            <mat-header-cell [crud-column-header]="columns.column('srpDetails.businessUnit.buId')" *matHeaderCellDef
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.BusinessUnit"> Business Unit </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              {{element.details?.attributes?.businessUnit?.buId}} - {{element.details?.attributes?.businessUnit?.name}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="user.externalAuthTypes">
            <mat-header-cell [crud-column-header]="columns.column('user.externalAuthTypes')" *matHeaderCellDef
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.User.externalAuthTypes"> External Auth Types </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              <span *ngFor="let userType of element.user?.externalAuthTypes">
                {{userType|refCodeDecode:'SEC_USER_DETAIL_TYPE'|async}}
                &nbsp;</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="user.authTypes">
            <mat-header-cell [crud-column-header]="columns.column('user.authTypes')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.User.authTypes"> Auth Types </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              <span *ngFor="let userType of element.user?.authTypes">
                {{userType|refCodeDecode:'SEC_USER_DETAIL_TYPE'|async}}
                &nbsp;</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="user.userTypes">
            <mat-header-cell [crud-column-header]="columns.column('user.userTypes')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.User.userTypes"> All User Types </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              <ng-container *ngFor="let userType of element.user?.userTypes">
                {{userType|refCodeDecode:'SEC_USER_DETAIL_TYPE'|async}}
                &nbsp;</ng-container>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="user.roles">
            <mat-header-cell [crud-column-header]="columns.column('user.roles')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.User.roles"> Roles (direct) </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              {{displayRoles(element.user?.roles)}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="user.allRoles">
            <mat-header-cell [crud-column-header]="columns.column('user.allRoles')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.User.allRoles"> Roles (all) </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              {{displayRoles(element.user?.allRoles)}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="user.enabled">
            <mat-header-cell [crud-column-header]="columns.column('user.enabled')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.User.enabled"> Enabled </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.user?.enabled">check_box</mat-icon>
              <mat-icon *ngIf="!element.user?.enabled">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="user.systemProvided">
            <mat-header-cell [crud-column-header]="columns.column('user.systemProvided')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.User.systemProvided"> System Provided </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.user?.systemProvided">check_box</mat-icon>
              <mat-icon *ngIf="!element.user?.systemProvided">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit"
                id="actions.edit">Edit</button>
              <button class="action-button" *ngIf="allowsView(element)" mat-raised-button color="primary"
                [routerLink]="viewRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.view"
                id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsViewSrpUserDetails(element)"
                [disabled]="!enabledViewSrpUserDetails(element)" mat-raised-button color="accent"
                [routerLink]="viewOrEditRouteToSrpUserDetails(element)" i18n="@@type.UserDetails"
                id="actions.viewOrEditRouteToSrpUserDetails">eTimber Details</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary"
        [routerLink]="createRoute()" [queryParams]="createRouteQueryParams()" i18n="@@actions.create"
        id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>
